/**
 * Same {error:[{field,messages}]} shape as the other settings pages
 * (AppExceptionRenderer.php). OrganizationsUsers write errors mostly come
 * back as plain top-level messages (owner-only, last-owner guard), so this
 * favors data.message with the structured shape as a fallback.
 */
export function parseGeneralError(error, fallback) {
  const data = error?.response?.data;

  if (data?.message) {
    return data.message;
  }

  const entries = Array.isArray(data?.error) ? data.error : [];
  const messages = entries.flatMap((entry) => entry.messages || []);
  if (messages.length) {
    return messages.join(" ");
  }

  return error?.message || fallback;
}
